import { fetchContactGroups } from "../../contacts/actions/fetchContactGroups";

export const FETCH_CONTACT_GROUPS_SUCCESS = "FETCH_CONTACT_GROUPS_SUCCESS";
export const ADD_CONTACT_GROUP = "ADD_CONTACT_GROUP";
export const UPDATE_CONTACT_GROUP = "UPDATE_CONTACT_GROUP";

export function fetchContactGroupsSuccess(contactGroups) {
    return {
        type: FETCH_CONTACT_GROUPS_SUCCESS,
        payload: contactGroups
    };
}

export function addContactGroup(contactGroup) {
    return {
        type: ADD_CONTACT_GROUP,
        payload: contactGroup
    };
}

export function updateContactGroup(contactGroup) {
    return {
        type: UPDATE_CONTACT_GROUP,
        payload: contactGroup
    };
}

export function loadContactGroups() {
    return (dispatch, getState) => {
        fetchContactGroups(contactGroups => {
            dispatch(fetchContactGroupsSuccess(contactGroups));
        });
    };
}



/** WEBPACK FOOTER **
 ** ./src/main/javascript/contacts/actions/contactsActions.js
 **/